export default __webpack_public_path__ + "static/media/flag_usa.8b2ad05e.png";